import { FileTypes, SkuFilter, ViewBy } from '..';
import { Frequency } from './types/frequency.type';
import { PricePer } from './types/price-per.type';
import { TimeSeriesData } from './types/time-series-data.type';

export class Extraction {
    constructor(
        public id: number,
        public title: string,
        public description: string,
        public startDate: Date,
        public endDate: Date,
        public pricePer: PricePer,
        public currency: string,
        public frequency: Frequency,
        public viewBy: ViewBy,
        public dateCreated: Date,
        public timeSeriesData: TimeSeriesData[],
        public includeAttributesFile: boolean,
        public fileType: FileTypes,
        public skuFilters: SkuFilter,
        public skuCount: number,
        public status: ExtractionStatus
    ) {}
}

export type ExtractionStatus = 'Pending' | 'Done' | 'Failed' | 'TimedOut';
